"use client"

import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import SearchIcon from "@/components/icons/SearchIcon"
import { Button } from "antd"
import type { FC } from "react"
import { useTranslation } from "react-i18next"

type ButtonSearchProps = {
  onClick: () => void
  compact?: boolean
  loading?: boolean
  /** Chiếm hết chiều rộng cột chứa nó — dùng khi đứng cùng hàng với nhiều field khác
   * (ngày đi/số người/loại visa), tránh minWidth cố định làm tràn cột hẹp. */
  fullWidth?: boolean
}

const ButtonSearch: FC<ButtonSearchProps> = ({ onClick, compact = false, loading = false, fullWidth = false }) => {
  const { t } = useTranslation()
  const isDesktop = useIsDesktop()

  // Bản compact (gắn trong tab-bar trang chủ) giữ nguyên kích thước dùng chung với các
  // tab khác (flight/hotel/tour/esim). Bản standalone (trang /dich-vu-visa) nhỏ + bo tròn
  // hơn để nhẹ nhàng, khớp với card kính mờ. Bản fullWidth (đứng cùng hàng 4 field khác)
  // KHÔNG tự set height — để size="large" tự quyết định, khớp hệt Input/Select/DatePicker
  // bên cạnh (tự set height riêng dễ lệch vì antd tính height 2 nhóm component không giống
  // nhau y hệt).
  const compactStyle = compact
    ? { height: "4.4rem", width: "4.4rem", minWidth: "4.4rem", padding: 0 }
    : fullWidth
      ? { fontSize: "1.5rem" }
      : {
          width: "17rem",
          maxWidth: "100%",
          height: "5rem",
          paddingInline: "2.5rem",
          border: 0,
          borderRadius: "1.2rem",
          background: "#f5225d",
          color: "#ffffff",
          fontSize: "1.5rem",
          fontWeight: 600,
        }

  return (
    <Button
      block={fullWidth || (!isDesktop && !compact)}
      type="primary"
      size="large"
      shape={compact ? undefined : "round"}
      icon={<SearchIcon style={{ fontSize: compact ? "1.6rem" : "2.2rem" }} />}
      style={compactStyle}
      loading={loading}
      onClick={onClick}
    >
      {compact ? null : isDesktop ? t("visa.button_search.desktop") : t("visa.button_search.mobile")}
    </Button>
  )
}

export default ButtonSearch
